import { normalizeForkSeekPaidPlanKey } from '../../supabase/functions/_shared/forkSeekAuthContinuation';

export type SeekPlanContinuationCandidate = {
  id: string;
  plan_key: string;
  is_free?: boolean | null;
};

export type SeekPlanContinuationReadiness = {
  plansLoading: boolean;
  subscriptionLoading: boolean;
  pricingLoading: boolean;
  pricingError: boolean;
  plansError: boolean;
  subscriptionError: boolean;
};

export function normalizeSeekPlanContinuation(value?: string | null): string | null {
  return normalizeForkSeekPaidPlanKey(value);
}

export function findSeekPlanContinuation<T extends SeekPlanContinuationCandidate>(
  value: string | null | undefined,
  plans: readonly T[],
): T | null {
  const planKey = normalizeSeekPlanContinuation(value);
  if (!planKey) return null;

  const plan = plans.find((candidate) => candidate.plan_key === planKey) ?? null;
  return plan && plan.is_free !== true ? plan : null;
}

export function isSeekPlanContinuationReady(
  readiness: SeekPlanContinuationReadiness,
): boolean {
  return !readiness.plansLoading
    && !readiness.subscriptionLoading
    && !readiness.pricingLoading
    && !readiness.pricingError
    && !readiness.plansError
    && !readiness.subscriptionError;
}

export function removeSeekPlanContinuation(searchParams: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(searchParams);
  next.delete('plan');
  return next;
}
